import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router';
import {useDebounceFn, useMemoizedFn} from 'ahooks';
import { Modal } from 'antd';
import toast from 'react-hot-toast';
import global from '@/utils/global';
import { IClearHighlightPayload, IDeleteNotePayload, IUpdatePanel, IhightLightItem } from '@/utils/ctype';
import { logCount, logError } from '@/utils/logger/arms-config';
import store, { useAppSelector} from '@/stores/index';
import { useAppDispatch } from '@/stores/index';
import {getWritingAsync, getAnswerListAsync, setPanelDataByIndex, setFocusIndex,
  saveAnswer, saveAnswerListAsync, updateTimeState, updateRecordId, 
  saveHighlightData, submitAnswerAsync, toggleShowNotePanel, clearHightLightInfo, updatePanelInfo, deleteNote} from '@/stores/slice/writing';
import { getStudentInfoAsync } from '@/stores/slice/user';
import { saveAnswerList } from '@/api/writing';
import NotePanel from '../../components/NotePanel';
import Bottom from '../../components/Bottom';
import Main from '../../components/Main';
import Loading from '../../components/Loading';
import { Score } from '../../components/Score';
import MainContent from './MainContent';
import style from './index.module.less';



export default function MockWriting() {

  global.subject = 'write';
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const params = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAI = location.pathname.includes('/mockwritingai');
  const {showNotePanel, answerAll, limits, currentFocus, pageDataIndex, 
    loadAnswered, highLightInfo, pageDataCache, surplus_time, essay, big_essay, recordId} = useAppSelector(state => state.writing);
  const {isVip} = useAppSelector(state => state.user.userPermission.writing); 
  const routeRecordId = Number(params.recordId);
  const [loadedRecordId, setLoadedRecordId] = useState<number | null>(null);
  const draftLoaded = loadedRecordId === routeRecordId;

  useEffect(() => {
    dispatch(updateRecordId(routeRecordId));
  }, [dispatch, routeRecordId]);

  useEffect(() => {
    if (!isAI && draftLoaded) {
      const timer = setInterval(() => {
        dispatch(saveAnswerListAsync());
      }, 10000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [draftLoaded, isAI, dispatch]);

  // 更新时间
  useEffect(() => {
    if (!isAI && draftLoaded) {
      const lastTime = [0, 0];
      const fn = () => {
        const writing = store.getState().writing;
        const idx = writing.pageDataIndex;
        try {
          if (idx !== 0 && idx !== 1) {
            return;
          }

          if (lastTime[0] + lastTime[1] > 5) {
            const obj: any = {
              record_id: routeRecordId,
            };
            if (lastTime[0] > 0) {
              obj['task1_duration'] = lastTime[0];
              lastTime[0] = 0;
            }
            if (lastTime[1] > 0) {
              obj['task2_duration'] = lastTime[1];
              lastTime[1] = 0;
            }
            saveAnswerList(obj);
          } else {
            lastTime[idx] = 1 + lastTime[idx];
          }

        } catch (e) {
          logError(e as any);
        }
      };
      const timer = setInterval(fn, 1000);
      return () => {
        clearInterval(timer);
        console.log('Finish');
        fn();
      };
    }
  }, [draftLoaded, isAI, routeRecordId]);

  // 如果是支付页面跳转过来,submit === '1' 是需要直接提交
  useEffect(() => {
    if (query.get('submit') === '1' && loadAnswered) {
      setShowloading(true);
      dispatch(submitAnswerAsync()).then((res2) => {
        if (!res2 || !res2.payload) {
          setShowloading(false);
          logError('提交失败');
          logError('Submit writing failed');
          logCount('Submit_Answer_Writing_P15');
          return;
        }
        setShowloading(false);
        if (res2?.payload) {
          navigate(`/mockstart/${recordId}`, {replace: true});
        }
      }).catch(err => {
        setShowloading(false);
      });
    }
  }, [loadAnswered]);

  useEffect(() => {
    let active = true;
    setLoadedRecordId(null);
    // 获取数据
    const answerRequest = dispatch(getAnswerListAsync({record_id: routeRecordId}));
    const contentRequest = dispatch(getWritingAsync({record_id: routeRecordId}));
    void Promise.all([answerRequest.unwrap(), contentRequest.unwrap()])
      .then(() => {
        if (active) {
          setLoadedRecordId(routeRecordId);
        }
      })
      .catch(() => undefined);
    dispatch(getStudentInfoAsync());
    return () => {
      active = false;
      answerRequest.abort();
      contentRequest.abort();
    };
  }, [dispatch, routeRecordId]);
  
  const setPanelHandle = (index: number) => {
    dispatch(setPanelDataByIndex({index}));
  };

  const setFocusIndexHandle = (index: number) => {
    dispatch(setFocusIndex({index}));
  };

  const { run, cancel, flush } = useDebounceFn(() => {
    if (draftLoaded) {
      dispatch(saveAnswerListAsync());
    }
  }, { wait: 1500, });
  useEffect(() => cancel, [cancel, routeRecordId]);

  const saveAnswerHandle = (obj: {key: string; value: string;}) => {
    if (!draftLoaded) {
      return;
    }
    toast.dismiss('writing-length');
    dispatch(saveAnswer(obj));
    run();
  };

  const saveHighlightDataHandle =(params: {show: boolean;wrapUid: string;} & IhightLightItem) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(saveHighlightData(params));
    run();
  };

  const updateTimeHandle = (value: number) => {
    dispatch(updateTimeState(value));
  };

  const isSubmit = useRef<boolean>(false);

  const [showLoading, setShowloading] = useState(false);
  const submitHandle = useMemoizedFn((callback: () => void ) => {
    if (!draftLoaded) {
      return;
    }
    if (isAI) {
      return;
    }
    // if (isSubmit.current === true) {
    //   return;
    // }
    // isSubmit.current = true;
    logCount('Submit_Answer_Writing_P1');
    if (showLoading) {
      return;
    }
    logCount('Submit_Answer_Writing_P2');
    
    setShowloading(true);
    dispatch(saveAnswerListAsync()).then((res) => {
      if (!res || !res.payload) {
        setShowloading(false);
        logError('Save writing before submit failed');
        logCount('Submit_Answer_Writing_P13');
        return;
      }
      logCount('Submit_Answer_Writing_P3');
      if ((res?.payload as {id: number;})?.id !== undefined) {
        logCount('Submit_Answer_Writing_P4');
        logCount('Submit_Answer_Writing_P5');
        dispatch(submitAnswerAsync()).then((res2) => {
          if (!res2 || !res2.payload) {
            setShowloading(false);
            logError('提交失败');
            logError('Submit writing failed');
            logCount('Submit_Answer_Writing_P14');
            return;
          }
          logCount('Submit_Answer_Writing_P6');
          setShowloading(false);
          if (res2?.payload) {
            logCount('Submit_Answer_Writing_P7');
            callback();
            navigate(`/mockstart/${recordId}`, {replace: true});
          }
          // isSubmit.current = false;
        }).catch(err => {
          logCount('Submit_Answer_Writing_P8');
          logError(err);
          setShowloading(false);
          // isSubmit.current = false;
        });
      }
    }).catch(err => {
      setShowloading(false);
      logError(err);
      logCount('Submit_Answer_Writing_P12');
      // isSubmit.current = false;
    });
  });

  const noteHandle = () => {
    dispatch(toggleShowNotePanel());
  };

  const clearDialogHandle= (payload?: IClearHighlightPayload) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(clearHightLightInfo(payload));
    run();
  };

  const updateDialogInfo = (info: IUpdatePanel) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(updatePanelInfo(info));
    run();
    flush();
  };

  const deleteNoteHandle = (payload: IDeleteNotePayload) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(deleteNote(payload));
    run();
  };

  const scoreNode = useMemo(() => {
    if (!isAI || !pageDataCache || !pageDataCache[pageDataIndex]) {
      return null;
    }
    return <Score type={pageDataIndex === 0 ? 5 : 4} value={pageDataCache[pageDataIndex].question.score} recordId={recordId}/>;
  }, [isAI, recordId, pageDataIndex, pageDataCache]);

  return (
    <div className={style.viewBox}>
      <Main course="w" pageData={pageDataCache[pageDataIndex]} time={surplus_time} 
        loadAnswered={loadAnswered} highLightObj={highLightInfo[pageDataIndex]} 
        updateTimeHandle={updateTimeHandle} saveHighlightDataHandle={saveHighlightDataHandle}
        submitHandle={submitHandle} noteHandle={noteHandle} showNotePanel={showNotePanel}
        headerChildren={scoreNode}
        isAI={isAI}
        clearDialogHandle={clearDialogHandle}
        notePanel={<NotePanel showNotePanel={showNotePanel} highLightInfo={highLightInfo} noteHandle={noteHandle}
          updateNoteHandle={updateDialogInfo} deleteNoteHandle={deleteNoteHandle}></NotePanel>}>
        {
          pageDataCache.map((pageDataItem, index: number) => {
            return (
              pageDataItem ? <MainContent isAI={isAI} key={index} value={index === 0 ? essay : big_essay} saveAnswerHandle={saveAnswerHandle} pageData={pageDataItem} index={index} boxStyle={{display: pageDataIndex === index ? '' : 'none'}}></MainContent> : null
            );
          })
        }
      </Main>
      <Bottom limits={limits} answerAll={answerAll} currentFocus={currentFocus} setPanelHandle={setPanelHandle} pageDataIndex={pageDataIndex} setFocusIndexHandle={setFocusIndexHandle} showNotePanel={showNotePanel}></Bottom>
      <Loading show={showLoading}></Loading>
    </div>
  );
}
